module.exports = __webpack_public_path__ + "img/quireup.8fa533f3.svg";